export const adSlotLocations = [
  { id: 'home_bottom', name: 'Home Page - Bottom', description: 'Banner di bagian bawah halaman utama' },
  { id: 'bot_dashboard', name: 'Bot List', description: 'Banner di halaman bot list' },
  { id: 'market_sidebar', name: 'Account', description: 'Banner di halaman account' },
];

export const sampleAds = [
  {
    id: 1,
    title: 'Premium Subscription Promo',
    imageUrl: 'https://via.placeholder.com/800x200/4f46e5/ffffff?text=Premium+Subscription+Promo',
    targetUrl: '/subscription/premium',
    slotLocation: 'home_top',
    startDate: '2025-05-01',
    endDate: '2025-07-30',
    isActive: true,
    impressions: 4562,
    clicks: 378,
    ctr: '8.29%'
  },
  {
    id: 2,
    title: 'New Bot Release',
    imageUrl: 'https://via.placeholder.com/800x200/2563eb/ffffff?text=New+Bot+Release',
    targetUrl: '/bots/new-release',
    slotLocation: 'bot_dashboard',
    startDate: '2025-05-15',
    endDate: '2025-06-30',
    isActive: true,
    impressions: 3210,
    clicks: 187,
    ctr: '5.83%'
  },
  {
    id: 3,
    title: 'Trading Academy',
    imageUrl: 'https://via.placeholder.com/300x600/059669/ffffff?text=Trading+Academy',
    targetUrl: '/academy',
    slotLocation: 'market_sidebar',
    startDate: '2025-04-10',
    endDate: '2025-08-10',
    isActive: true,
    impressions: 2845,
    clicks: 196,
    ctr: '6.89%'
  },
  {
    id: 4,
    title: 'Crypto Conference 2025',
    imageUrl: 'https://via.placeholder.com/800x200/d97706/ffffff?text=Crypto+Conference+2025',
    targetUrl: '/events/crypto-conf',
    slotLocation: 'portfolio',
    startDate: '2025-06-01',
    endDate: '2025-06-15',
    isActive: false,
    impressions: 0,
    clicks: 0,
    ctr: '0.00%'
  },
  {
    id: 5,
    title: 'Mobile App Promotion',
    imageUrl: 'https://via.placeholder.com/800x200/7c3aed/ffffff?text=Mobile+App+Promotion',
    targetUrl: '/mobile-app',
    slotLocation: 'home_bottom',
    startDate: '2025-05-20',
    endDate: '2025-07-20',
    isActive: true,
    impressions: 5124,
    clicks: 423,
    ctr: '8.26%'
  }
];

export const getAdSlotName = (slotId) => {
  const slot = adSlotLocations.find(slot => slot.id === slotId);
  return slot ? slot.name : slotId;
};
